/**
 * LES DOCUMENTS IT SOLUTIONS, dans le menu « Aide » (DEC-036) — le flipbook
 * (publié sur Publuu) et ceux du site www (ITS-53/www, conteneur www-docs),
 * jamais recopiés ici : la borne pointe vers eux, et ce qu'ils disent se tient
 * là-bas.
 */
export interface LienAide {
  key: string;
  label: string;
  url: string;
}

export const LIENS_AIDE: readonly LienAide[] = [
  { key: 'aide-flipbook', label: 'Flipbook', url: 'https://publuu.com/flip-book/698120/2243517' },
  { key: 'aide-sav', label: 'SAV', url: 'https://sav.it-solutions.cloud' },
  { key: 'aide-tarifs', label: 'Tarifs', url: 'https://tarifs.it-solutions.cloud' },
  { key: 'aide-cgv', label: 'CGV', url: 'https://cgv.it-solutions.cloud' },
];
